import React, { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';
import { Button, Dialog, Table, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import { useQuery } from 'hooks/useQuery';
import { launchPrivider } from 'services';
import * as Yup from 'yup';

import { DialogEditClient } from '../DialogEditClient';
import { DialogRegisterVinc } from '../DialogRegisterVinc';

const columns = [
  { label: 'Cliente', align: 'center' },
  { label: 'Editar', align: 'center' },
  { label: 'Vincular', align: 'center' },
];

const validationSchema = Yup.object().shape({
  client: Yup.string().required('O nome do cliente é obrigatório'),
});

export const DialogVincClients = ({ open, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [clientsLaunch, , , reftchClientsLaunch] = useQuery(
    () => launchPrivider.findClientsLaunch(),
    [],
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openDialogEdit, setOpenDialogEdit] = useState(false);
  const [openDialogRegisterVinc, setOpenDialogRegisterVinc] = useState(false);
  const [line, setLine] = useState({});

  const onSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    try {
      await launchPrivider.createClientLaunch({ name_client: values.client });
      toast.success('Cliente Cadastrado com sucesso!');
      resetForm();
      reftchClientsLaunch();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Erro ao Cadastrar Cliente!');
    } finally {
      setIsLoading(false);
    }
  };

  const toInputUppercase = (e) => {
    e.target.value = ('' + e.target.value).toUpperCase().trim();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const pagined = clientsLaunch?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleOpenDialogEdit = (item) => {
    setOpenDialogEdit(true);
    setLine(item);
  };

  const handleCloseDialogEdit = () => {
    setOpenDialogEdit(false);
    reftchClientsLaunch();
  };

  const handleOpenDialogRegisterVinc = (item) => {
    setOpenDialogRegisterVinc(true);
    setLine(item);
  };

  const handleCloseDialogRegisterVinc = () => {
    setOpenDialogRegisterVinc(false);
  };

  return (
    <>
      <Dialog maxWidth={'sm'} open={open}>
        <Dialog.Title onClose={onClose}>Cadastro/Vinculo de Cliente</Dialog.Title>
        <Formik
          initialValues={{ client: '' }}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form>
            <Dialog.Content>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Field
                    label='Nome Cliente'
                    variant='outlined'
                    name='client'
                    size='small'
                    component={Text}
                    onInput={toInputUppercase}
                  />
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: '1rem' }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Table
                    headers={columns}
                    disableNumeration
                    emptyMessage='Nenhum Cliente encontrado'
                  >
                    {pagined?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell align='center'>{item.cliente}</TableCell>
                        <TableCell align='center'>
                          <IconButton color='primary' onClick={() => handleOpenDialogEdit(item)}>
                            <EditIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell align='center'>
                          <IconButton
                            color='secondary'
                            onClick={() => handleOpenDialogRegisterVinc(item)}
                          >
                            <LinkIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </Table>
                  <TablePagination
                    component='div'
                    count={clientsLaunch?.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    labelRowsPerPage='Linhas por página'
                  />
                </Grid>
              </Grid>
            </Dialog.Content>

            <Dialog.Actions>
              <Button fullWidth color='secondary' onClick={onClose} loading={isLoading}>
                Cancelar
              </Button>
              <Button fullWidth loading={isLoading} type='submit'>
                Cadastrar
              </Button>
            </Dialog.Actions>
          </Form>
        </Formik>
      </Dialog>

      <DialogRegisterVinc
        open={openDialogRegisterVinc}
        onClose={handleCloseDialogRegisterVinc}
        line={line}
      />
      <DialogEditClient open={openDialogEdit} onClose={handleCloseDialogEdit} line={line} />
    </>
  );
};
